import React from 'react';

import FireIcon from '@/assets/icons/fire';
import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

import { PaymentTag } from './PaymentTag';

export const PopularTag = () => {
    return (
        <PaymentTag
            icon={<FireIcon color={ds.colorValue.icon.accent.orange} />}
            translationKey="popular"
            color={ds.colorToken.text.accent.orange}
            backgroundColor={withOpacity(ds.colorValue.background.accent.orange.strong, 0.16)}
        />
    );
};
